//Get array items in cart 
export const GET_CART = 'cart';

//Add item to cart
export const ADD_TO_CART = 'cart/add';

//Add item to cart
export const REMOVE_FROM_CART = 'cart/delete';

//Empty cart
export const CLEAR_CART = 'cart/reset';


// WEBPACK FOOTER //
// ./src/store/actions/cartActionTypes.js